import { useEnsureAIHubSharedExecutionContext } from '@office-start/ai-hub-execution-context-provider-lazy';
import { AiHubPageUnstyled } from '@office-start/ai-hub-page-component';
import { logModuleLoadDuration } from '@office-start/ai-hub-telemetry-service';
import { useLogPageView } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var componentName = 'Actions';
var AutomateComponentLazyBoundary = lazy(function () {
    var loadPromise = import(
    /* webpackChunkName: "automate" */ '@1js/ai-hub-automation-module-loader').then(function (module) { return ({
        default: function () { return (React.createElement(module.AutomationModuleRootComponent, { valueForAutomationRootComponent: true })); },
    }); });
    return logModuleLoadDuration(loadPromise, componentName);
});
AutomateComponentLazyBoundary.displayName = 'AutomateComponent';
export var AutomatePage = function () {
    // while we download the actions component, we need to ensure the AIHub shared execution context is loaded
    // this is because the actions component uses the AIHub shared execution context in both V3 and V2
    useEnsureAIHubSharedExecutionContext();
    return AutomatePageElement();
};
export var AppHostedAutomatePage = function () {
    // We do not need to ensure the AIHub shared execution context
    // is loaded here as MetaOSWrapper will be responsible for loading it.
    return AutomatePageElement();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function AutomatePageElement() {
    return (React.createElement(AiHubPageUnstyled, { useLogPageViewHook: useLogPageView, name: "Actions", LazyComponent: AutomateComponentLazyBoundary, componentName: componentName }));
}
//# sourceMappingURL=AutomatePage.js.map